import { useState } from 'react';
import { Stack, Box, Modal, Radio, Typography } from '@mui/material';
import MuiButton from 'components/Common/Button/MuiButton';
import { modalStyle } from './ModalStyles';

type PhoneSelectionModalProps = {
    isOpen: boolean;
    onClose: () => void;
    phoneNumberList: string[];
    onSubmit: (selectedPhoneNumber: string) => void;
}

const PhoneSelectionModal = ({
    isOpen,
    onClose,
    phoneNumberList,
    onSubmit
}: PhoneSelectionModalProps) => {
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState<string>('');
    const replacePhoneNumber = (phoneNumber) => {
        if (
            phoneNumber.replace(/\D/g, '').length !== 10
        ) {
            return 'Invalid phone number on file';
        }
        const replacedNumber = 'XXX-XXX' + phoneNumber.slice(7);
        return replacedNumber;
    };
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    ...modalStyle,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    width: {
                        xs: '90%',
                        sm: '50%',
                    },
                    maxWidth: '100%',
                }}
            >
                <div className="justify-content-center">
                    <Typography component="div" variant="h5">
                        Where to send the verification code?
                    </Typography>

                    {phoneNumberList.map((phoneNumber, index) => (
                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{ paddingTop: '3px' }}
                        >
                            <Radio
                                value={phoneNumber}
                                onClick={() =>
                                    setSelectedPhoneNumber(phoneNumber)
                                }
                            />
                            <Typography className="align-content-center">
                                {replacePhoneNumber(phoneNumber)}
                            </Typography>
                        </Stack>
                    ))}

                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{ paddingTop: '10px' }}
                    >
                        <MuiButton
                            sx={{ width: '100%' }}
                            disabled={!selectedPhoneNumber}
                            onClick={() => onSubmit(selectedPhoneNumber)}
                        >
                            Send Code
                        </MuiButton>
                        <MuiButton
                            sx={{ width: '100%' }}
                            variant="outlined"
                            onClick={() => {
                                setSelectedPhoneNumber('');
                                onClose();
                            }}
                        >
                            Cancel
                        </MuiButton>
                    </Stack>
                </div>
            </Box>
        </Modal>
    );
};

export default PhoneSelectionModal;
